(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/containers/wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/containers/wrapper.js');
'use strict';

const tickets = svs.tickets;
const Wrapper = _ref => {
  let children = _ref.children,
    imagePosition = _ref.imagePosition;
  const Background = tickets.next.containers.Background;
  if (typeof Background !== 'function') {
    return React.createElement("div", {
      className: "triss-next-layout-wrapper u-flex u-flex-column"
    }, children);
  }
  return React.createElement(Background, {
    imagePosition: imagePosition
  }, React.createElement("div", {
    className: "triss-next-layout-wrapper u-flex u-flex-column"
  }, children));
};
setGlobal('svs.tickets.next.containers.Wrapper', Wrapper);

 })(window);